import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import BannerCarousel from '../components/BannerCarousel';
import ProductCard from '../components/ProductCard';
import Cart from '../components/Cart';
import ProductModal from '../components/ProductModal';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CategoryPage = () => {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCart, setShowCart] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { getItemCount } = useCart();

  useEffect(() => {
    fetchCategoryAndProducts();
  }, [slug]);

  const fetchCategoryAndProducts = async () => {
    try {
      const catResponse = await axios.get(`${API}/categories`);
      const foundCat = catResponse.data.find(c => c.slug === slug);
      setCategory(foundCat);

      const prodResponse = await axios.get(`${API}/products/category/${slug}`);
      setProducts(prodResponse.data);
    } catch (error) {
      console.error('Erro ao carregar categoria:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleAddToCart = () => {
    toast.success(`${selectedProduct.nome} adicionado ao carrinho!`, {
      duration: 3000,
      action: {
        label: 'Ver Carrinho',
        onClick: () => setShowCart(true)
      }
    });
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.5rem' }}>Carregando...</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#FAFAFA' }}>
      <Header 
        onSearch={() => {}} 
        cartCount={getItemCount()} 
        onCartClick={() => setShowCart(true)}
      />

      {category && (
        <div style={{ padding: '2rem 0' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
            <h1 style={{ 
              fontFamily: 'Playfair Display, serif', 
              fontSize: '2.5rem', 
              marginBottom: '0.5rem' 
            }}>
              {category.nome}
            </h1>
            {category.descricao && (
              <p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '2rem' }}>
                {category.descricao}
              </p>
            )}
          </div>

          <BannerCarousel categoriaId={category.id} />

          <div style={{ maxWidth: '1200px', margin: '2rem auto', padding: '0 1rem' }}>
            {products.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666', fontSize: '1.1rem', padding: '3rem 0' }}>
                Nenhum produto nesta categoria ainda.
              </p>
            ) : (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                gap: '1.5rem'
              }}>
                {products.map(product => (
                  <div key={product.id} onClick={() => handleProductClick(product)}>
                    <ProductCard product={product} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <Cart open={showCart} onClose={() => setShowCart(false)} />
      
      <ProductModal
        product={selectedProduct}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onAddToCart={handleAddToCart}
      />
    </div>
  );
};

export default CategoryPage;